import { useEffect } from 'react'

import { useCallbackRef } from '@tribeplatform/react-ui-kit/hooks'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'
import { Tooltip } from '@tribeplatform/react-ui-kit/Tooltip'

import { useSiteTreeContext } from '../contexts/SiteTreeContext.js'
import { useCollectionSpacesTreeItems } from '../hooks/useCollectionSpacesTreeItems.js'
import { CollectionTreeItemProps } from '../types.js'

import { CollectionMenu } from './CollectionMenu.js'

export function CollectionTreeItem({
  collection,
  enabled,
  setSpaces: _setSpaces,
}: CollectionTreeItemProps) {
  const context = useSiteTreeContext()
  const { activeSpaceTreeIndex, activeSpaceCollectionId } = context

  const treeItems = useCollectionSpacesTreeItems({
    id: collection.id,
    variables: {
      collectionId: collection.id,
    },
    enabled,
    ensureVisible:
      collection.id === activeSpaceCollectionId
        ? activeSpaceTreeIndex
        : undefined,
  })
  const setSpaces = useCallbackRef(_setSpaces)

  useEffect(() => {
    if (enabled) {
      setSpaces(treeItems)
    }
  }, [treeItems, setSpaces, collection.id, enabled])

  const showCollectionMenu = context.collection?.showMenu

  return (
    <div className="flex w-full justify-between p-2">
      <div className="grid grid-cols-[auto_1fr] items-center gap-2">
        <SvgIcon name="folder" />
        <Tooltip>
          <Tooltip.Trigger asChild>
            <span className="truncate">{collection.name}</span>
          </Tooltip.Trigger>
          <Tooltip.Panel>{collection.name}</Tooltip.Panel>
        </Tooltip>
      </div>
      {showCollectionMenu && (
        <div className="flex items-center gap-2">
          <CollectionMenu collection={collection} />
        </div>
      )}
    </div>
  )
}
